export const parseReportResponse = (response, prepareData, report) => {
  // Public Top 50 uses horizon-keyed rows, not Data Search's authenticated pagination envelope.
  if (report === 'topPredictions') {
    if (response?.success !== true || !response.data || Array.isArray(response.data) ||
        typeof response.data !== 'object' || typeof prepareData !== 'function') {
      throw new Error('Invalid Top 50 response');
    }
    const data = prepareData(response.data);
    if (!Array.isArray(data)) throw new Error('Invalid Top 50 rows');
    return {data, count: data.length};
  }
  const rawCount = response?.['data-total-count'];
  const count = typeof rawCount === 'string' && /^\d+$/.test(rawCount) ? Number(rawCount) : rawCount;
  if (response?.success !== true || response?.isAuth === false || !Array.isArray(response.data) ||
      !Number.isSafeInteger(count) || count < 0 || count < response.data.length) {
    throw new Error('Invalid report response');
  }
  const data = prepareData ? prepareData(response.data) : response.data;
  if (!Array.isArray(data)) throw new Error('Invalid report rows');
  return {data, count};
};
